import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchCovidReport = (args) => {
    return doDefaultFetch(`/site/api/covidReport/${args.reportDate}`, args);
};

const fetchCovidReportDateRange = async () => {
    return doDefaultFetch('/site/api/covidReport/reportInfo/dateRange');
};

export default {
    fetchCovidReport,
    fetchCovidReportDateRange,
};
